import React, {Fragment} from 'react';
import classnames from 'classnames'
import {connect} from "dva";
import QRCode from 'qrcode.react';
import {Popover, Input, Badge, message, Affix} from 'antd'
import {Scrollbars} from 'react-custom-scrollbars';
import qs from 'qs';
import './index.scss';
import ImgAdapt from "../img-adapt";
import StorageUtil from "../../utils/storage-util";
import {LocalConst} from "../../utils/constant";
import {SystemFetch} from "../../services/service";
import CommonUtil from "../../utils/common-util";
import RenderUtil from "../../utils/render-util";
import UrlUtil from "../../utils/url-config";
import SvgIcon from "../svg-icon";
import {createIntl, injectIntl} from "react-intl";
import CheckUtil from "../../utils/check-util";
import zh_CN from "../../locale/zh_CN"; // 中文
import es_Es from "../../locale/es_ES" // 西班牙语
import en_Us from "../../locale/en_US" // 西班牙语

import de_DE from "../../locale/de_DE"; // 德语
import fr_FR from "../../locale/fr_FR"; // 法语
import ar_SA from "../../locale/ar_SA"; // 阿拉伯语
import ru_RU from "../../locale/ru_RU"; // 俄语
import ms_MY from "../../locale/ms_MY"; // 马来语
import vi_VN from "../../locale/vi_VN"; // 越南语
import th_TH from "../../locale/th_TH"; // 泰语
import id_ID from "../../locale/id_ID"; // 印尼语

import IMGDownloadQrCode from '../../assets/images/app-download-qrcode.png';

const IMGLogo = "https://img.ysdinghuo.com/361@jyNZuh@shop-logo.png";

// 多语言
const messages = {
    'zh': zh_CN,
    'es': es_Es,
    'en': en_Us,
    'de': de_DE,
    'fr': fr_FR,
    'ar': ar_SA,
    'ru': ru_RU,
    'ms': ms_MY,
    'vi': vi_VN,
    'th': th_TH,
    'id': id_ID,
};


@injectIntl
@connect(state => ({...state.appModel}))
class PageHeader extends React.Component {
    constructor(props) {
        super(props);
        const {history} = props;
        const query = qs.parse(history.location.search, {ignoreQueryPrefix: true});
        this.state = {
            keywordList: [],
            keyword: query.keyword_ || '',
            classifyList: [],
            isFixationHead: false,
            letter: 'all',
            cartCount: StorageUtil.getItem(LocalConst.cartCount),
            isShowCustomerServiceModal: false,
            wsConfig: {},
            serviceGroup: {},
            serviceGroupView: {},
            tabList: [
                { id: 1, name: '全部消息', isChecked: true },
                { id: 2, name: '未读消息', isChecked: false },
                { id: 3, name: '已读消息', isChecked: false },
            ],
            msgList: [],
            currentService: [],
            msg: '',
        };
        this.companyId = StorageUtil.getItem(LocalConst.companyId);
        this.companyData = StorageUtil.getItem(LocalConst.companyData);
        this.isLogin = CommonUtil.isLogin();
        this.user = StorageUtil.getItem(LocalConst.mShop_user);
        this.applicationStatus = StorageUtil.getItem(LocalConst.applicationStatus) || {};
        this.switchLanguageType = StorageUtil.getItem(LocalConst.switchLanguageType);
    }

    componentDidMount() {
        this.searchClientKeyWordList();
        if (this.isLogin) {
            this.initWebSocket();
        }
        this.pageScrollBox = document.querySelector('body');
        this.pageScrollBox.addEventListener('scroll', () => this.handleScroll());
        // 更新购物车
        window.addEventListener('setItemEvent', (e) => {
            if (e.key === LocalConst.cartCount) {
                this.setState({
                    cartCount: JSON.parse(e.newValue)
                })
            }
        });

        document.addEventListener('click', e => {
            this.setState({
                isShowSearchDropdown: false
            })
        }, false)
    }

    componentWillUnmount() {
        const {wsConfig} = this.state;
        if (wsConfig.ws) {
            wsConfig.ws.close();
        }
        if (this.interval) {
            clearInterval(this.interval);
        }
    };

    initWebSocket = () => {
        const wsConfig = {
            userId: '',          // 将在连接时设置
            userType: '',        // 'customer' 或 'support'
            currentChat: null,   // 当前聊天对象
            ws: null             // WebSocket连接
        };
        // let wsUrl = 'ws://106.15.54.84:8081/ws';
        // if (process.env.API_ENV === 'production') { // 正式环境
        //     wsUrl = 'wss://im.ysdinghuo.com/ws';
        // }
        let wsUrl = 'wss://im.ysdinghuo.com/ws';
        console.log('WsUrl=======================>', wsUrl);
        try {
            wsConfig.ws = new WebSocket(wsUrl);
            wsConfig.ws.onopen = () => {
                console.log('WebSocket连接已建立!');
                const user = StorageUtil.getItem(LocalConst.mShop_user);
                // 发送连接消息
                const connectMsg = {
                    senderId: user.id_,
                    senderType: 'CUSTOMER',
                    content: 'CONNECT',
                    type: 'SYSTEM'
                };
                wsConfig.ws.send(JSON.stringify(connectMsg));
                // 心跳检测
                this.interval = setInterval(() => {
                    const msg = {
                        senderId: user.id_,
                        type: 'HEARTBEAT'
                    };
                    wsConfig.ws.send(JSON.stringify(msg));
                }, 1000 * 30);
            };

            wsConfig.ws.onmessage = (event) => {
                const {serviceGroup, currentService} = this.state;
                const message = JSON.parse(event.data);
                console.log('推送客服消息message===>', message);
                console.log('serviceGroup===>', serviceGroup);
                console.log('currentService===>', currentService);
                if (message && message.receiverType === 'CUSTOMER') {
                    const data = JSON.parse(message.content);
                    console.log('推送客服消息data====>', data);
                    if (serviceGroup[data.service_user_id_].length) {
                        // 更新收到的消息和发送时间
                        serviceGroup[data.service_user_id_][0].create_time_ = this.transformDate(data.create_time_str_);
                        serviceGroup[data.service_user_id_][0].content_ = data.content_;
                        let notReadCount = serviceGroup[data.service_user_id_][0].notReadCount || 0;
                        serviceGroup[data.service_user_id_][0].notReadCount = notReadCount + 1;
                        if (currentService[0].service_user_id_ === data.service_user_id_) {
                            serviceGroup[data.service_user_id_][0].notReadCount = 0;
                        }
                        if (data.type_ === 2 || data.type_ === 3) {
                            serviceGroup[data.service_user_id_][0].content_ = '[图片]';
                        }
                        this.setState({
                            serviceGroup,
                            currentService: serviceGroup[data.service_user_id_]
                        }, () => {
                            const {currentService} = this.state;
                            this.getMsgList(currentService[0].client_id_, currentService[0].service_user_id_);
                        });
                    }
                }
            };

            wsConfig.ws.onclose = (event) => {
                console.log('WebSocket连接已关闭');
                console.log('event======>', event);
                console.log(`Code：${event.code}, Reason：${event.reason}`);
            };

            this.setState({
                wsConfig,
            });
        } catch (e) {
            console.error(e.message);
        }
    };

    changeTab = (tabId) => {
        let {tabList,queryParams,serviceGroup, msgList, currentService} = this.state;
        tabList.forEach(tab => {
            tab.isChecked = tab.id === tabId;
        });
        this.setState({
            tabList,
            queryParams
        }, () => {
            let serviceGroupView = {};
            if (tabId === 1) {
                serviceGroupView = serviceGroup;
            } else if (tabId === 2) {
                for (const key in serviceGroup) {
                    if (serviceGroup[key][0].notReadCount) {
                        serviceGroupView[key] = serviceGroup[key];
                    }
                }
            } else if (tabId === 3) {
                for (const key in serviceGroup) {
                    if (!serviceGroup[key][0].notReadCount) {
                        serviceGroupView[key] = serviceGroup[key];
                    }
                }
            }
            if (!Object.keys(serviceGroupView).length) { // 清空当前消息
                msgList = [];
                currentService = [];
            }
            this.setState({
                serviceGroupView,
                msgList,
                currentService,
            }, () => {
                let {serviceGroupView, currentService} = this.state;
                if (Object.keys(serviceGroupView).length) {
                    let isExist = false;
                    for (const key in serviceGroupView) {
                        if (serviceGroupView[key][0].active) {
                            isExist = true;
                            currentService = serviceGroupView[key];
                        }
                    }
                    if (!isExist) {
                        const keys = Object.keys(serviceGroupView);
                        currentService = serviceGroupView[keys[0]];
                        serviceGroupView[keys[0]][0].active = true; // 默认第一个选中
                    }
                    this.setState({
                        serviceGroupView,
                        currentService,
                    }, () => {
                        const {currentService} = this.state;
                        this.getMsgList(currentService[0].client_id_, currentService[0].service_user_id_);
                    });
                }
            });
        });
    };

    // 处理日期显示
    transformDate = (create_time_) => {
        const dayMilliseconds = 24 * 60* 60* 1000;
        let time = '';
        const yymmdd = create_time_.slice(0, 11);
        const today = new Date();
        const todayMilliseconds = new Date(today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()).getTime();
        const milliseconds = new Date(yymmdd).getTime();
        if (todayMilliseconds - milliseconds === dayMilliseconds) { // 昨天
            time = '昨天';
        } else {
            if (todayMilliseconds === milliseconds) { // 今天
                time = create_time_.slice(11, create_time_.length - 3);
            } else {
                time = create_time_.slice(5, 11);
            }
        }
        return time;
    };

    getClientServiceList = () => {
        const params = {
            showCount: 500,
            client_id_: this.user.client_id_,
        };
        SystemFetch.searchMsgList(params, rs => {
            if (rs.status === 1) {
                const pdList = (rs.data.pdList || []);
                pdList.forEach(item => {
                    if (item.type_ === 2 || item.type_ === 3) {
                        item.content_ = '[图片]';
                    }
                });
                this.handleServiceList(pdList);
            }
        });
    };

    // 客服列表数据
    handleServiceList = (pdList) => {
        const serviceGroup = {};
        pdList.forEach(item => {
            if (serviceGroup[item.service_user_id_]) {
                serviceGroup[item.service_user_id_].push(item);
            } else {
                serviceGroup[item.service_user_id_] = [item];
            }
        });
        const keyList = Object.keys(serviceGroup);
        // 统计未读消息
        for (const key in serviceGroup) {
            let notReadCount = 0;
            serviceGroup[key].forEach(item => {
                if (item.is_service_user_send_msg_ && !item.is_read_) {
                    notReadCount++;
                }
            });
            if (notReadCount) {
                serviceGroup[key][0].notReadCount = notReadCount;
            }
            serviceGroup[key][0].create_time_ = this.transformDate(serviceGroup[key][0].create_time_);
        }
        serviceGroup[keyList[0]][0].active = true; // 默认展示和第一个客服的聊天信息
        this.setState({
            serviceGroup,
            serviceGroupView: serviceGroup,
            currentService: serviceGroup[keyList[0]]
        }, () => {
            const {currentService} = this.state;
            this.getMsgList(currentService[0].client_id_, currentService[0].service_user_id_);
        });
    };

    toMsgList = (key) => {
        const {serviceGroup, serviceGroupView} = this.state;
        serviceGroup[key][0].notReadCount = 0;
        serviceGroupView[key][0].notReadCount = 0;
        for (const key1 in serviceGroup) {
            if (key1 === key) {
                serviceGroup[key1][0].active = true;
            } else {
                serviceGroup[key1][0].active = false;
            }
        }
        for (const key2 in serviceGroupView) {
            if (key2 === key) {
                serviceGroupView[key2][0].active = true;
            } else {
                serviceGroupView[key2][0].active = false;
            }
        }
        this.setState({
            serviceGroup,
            serviceGroupView,
            currentService: serviceGroupView[key]
        }, () => {
            this.getMsgList(serviceGroupView[key][0].client_id_, serviceGroupView[key][0].service_user_id_);
        });
    };

    getMsgList = (client_id_, service_user_id_) => {
        const params = {
            showCount: 500,
            client_id_,
            service_user_id_,
            is_service_user_: 0,
        };
        SystemFetch.searchMsgList(params, rs => {
            if (rs.status === 1) {
                const msgList = (rs.data.pdList || []).reverse();
                msgList.forEach(item => {
                    if (item.type_ === 2) { // 商品
                        item.content_ = JSON.parse(item.content_);
                    } else if (item.type_ === 3) { // 订单
                        item.content_ = JSON.parse(item.content_);
                        item.imgList = JSON.parse(JSON.stringify(item.content_.imgList));
                        if (item.imgList.length > 4) { // 最多显示四个
                            item.imgList.pop();
                        }
                    }
                });
                this.setState({
                    msgList,
                }, () => {
                    // 滚动到聊天底部
                    const chatMessageBox = document.getElementsByClassName('chat-message-box')[0];
                    if (chatMessageBox) {
                        chatMessageBox.scrollTop = chatMessageBox.scrollHeight;
                    }
                });
            }
        });
    };

    handleScroll = () => {
        const {pageHeader = {}} = this.props;
        const {banner_ = {}} = pageHeader;
        const {height_ = 0} = banner_;
        this.setState({
            isFixationHead: this.pageScrollBox.scrollTop > (64 + height_)
        });
    };

    searchClientKeyWordList = () => {
        if (!this.isLogin) return;
        var param = {
            company_id_: this.companyId,
            showCount: 10,
        };
        SystemFetch.searchClientKeyWordList(param, (rs) => {
            if (rs.status === 1) {
                this.setState({
                    keywordList: rs.data.pdList || []
                })
            }
        });
    };

    searchKeyWordList = () => {
        const {keyword} = this.state;
        const param = {
            company_id_: this.companyId,
            keyword_: keyword,
            showCount: 10
        };
        SystemFetch.searchKeyWordList(param, (rs) => {
            if (rs.status === 1) {
                this.setState({
                    keywordList: rs.data.pdList || []
                })
            }
        });
    };

    selectKeywordLog = (e, item) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        this.searchKeyword(item.keywords_);
        this.setState({
            keyword: item.keywords_
        });


    };
    changeKeyword = (e) => {
        this.setState({
            keyword: e.target.value
        }, () => {
            const {keyword} = this.state;
            if (keyword.length > 0 && this.isLogin) {
                this.searchKeyWordList()
            } else {
                this.searchClientKeyWordList()
            }
        })
    };
    searchKeyword = (keyword) => {
        const {history} = this.props;
        let keyword_ = encodeURIComponent(keyword);
        const path = `/goods/list?keyword_=${keyword_}`;
        if (history.location.pathname === '/goods/lis') {
            history.replace(path);
        } else {
            history.push(path);
        }
    };
    // 删除客户指定的搜索关键词
    toDeleteKeywordsById = (e, id_) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        SystemFetch.toDeleteKeywordsById(id_, (rs) => {
            if (rs.status) {
                message.success(rs.message)
                this.searchClientKeyWordList()
            } else {
                message.error(rs.message)
            }
        });
    };
    // 删除客户所有的搜索关键词
    toDeleteClientAllKeywords = () => {
        SystemFetch.toDeleteClientAllKeywords(null, (rs) => {
            if (rs.status) {
                message.success(rs.message)
                this.searchClientKeyWordList()
            } else {
                message.error(rs.message)
            }
        });
    };


    getClassifyByDecorateName = (key, navigation) => {
        let name = '';
        if (navigation && navigation.classify_list_) {
            navigation.classify_list_.forEach(item => {
                if (item.classify_type_ === key) {
                    name = item.name_
                }
            });
        }
        return name
    };
    getClassifyByDecorateSeq = (key, navigation) => {
        let seq = '';
        if (navigation && navigation.classify_list_) {
            navigation.classify_list_.forEach(item => {
                if (item.classify_type_ === key) {
                    seq = item.seq_
                }
            });
        }

        return seq
    };
    getClassifyByDecorateHidden = (key, navigation) => {
        let hidden = 0;
        if (navigation && navigation.classify_list_) {
            navigation.classify_list_.forEach(item => {
                if (item.classify_type_ === key) {
                    hidden = item.hidden_
                }
            });
        }
        return hidden
    };
    handlePropertyByDecorateSort = (key, list, navigation) => {
        let propertyList = [];
        if (navigation && navigation.classify_list_) {
            navigation.classify_list_.forEach(item => {
                list.forEach(l => {
                    if (item.classify_type_ === key && item.property_id_ === l.id_) {
                        l.type_ = 'property_' + l.id_;
                        l.hidden_ = item.hidden_;
                        l.seq_ = item.seq_;
                        l.children = item.children || [];
                        propertyList.push(l)
                    }
                })
            });
        }
        return propertyList
    };
    menuItemMouseEntre = (e) => {
        e.stopPropagation();
        const dataId = e.target.getAttribute('data-id');
        const selectItem = document.querySelector(`#jsSelect_${dataId}`);
        const menuActive = document.querySelectorAll(`.menu-active`);
        if (menuActive.length > 0) {
            menuActive.forEach(item => {
                const menuActiveId = document.querySelector(`#${item.id}`);
                if (`#jsSelect_${dataId}` !== `#${item.id}`) {
                    menuActiveId.classList.remove('menu-active')
                }
            })
        }
        if (selectItem) {
            selectItem.classList.add('menu-active')
        }
    };
    menuItemMouseLeave = () => {
        const menuActive = document.querySelectorAll(`.menu-active`);
        if (menuActive.length > 0) {
            menuActive.forEach(e => {
                const menuActiveId = document.querySelector(`#${e.id}`);
                menuActiveId.classList.remove('menu-active')
            })
        }
    };
    renderMenuItem = (sub, subIndex) => {
        return (
            <dl key={subIndex}>
                <dt onClick={() => this.selectQuery('type', sub)} role={'none'}>
                    {sub.name || sub.name_}
                </dt>
                {
                    (sub.children || []).map((i, sIndex) => {
                        return (
                            <dd key={sIndex} onClick={() => this.selectQuery('type', i)} role={'none'}>
                                {i.name}
                                {
                                    sIndex < sub.children.length - 1 &&
                                    <i className="short-line"/>
                                }
                            </dd>
                        )
                    })
                }
            </dl>
        )
    };
    selectLetter = (letter) => {
        this.setState({
            letter: letter
        })
    };
    renderMenuSubBoxList = (item, index) => {
        switch (item.type_) {
            case "type":
                let renderMenuItem = [];
                (item.children || []).forEach((sub, subIndex) => {
                    renderMenuItem.push(this.renderMenuItem(sub, subIndex))
                });
                return renderMenuItem || [];
            case "brand":
                const {letter} = this.state;
                return <div className='menu-brand-item-box' key={index}>
                    <div className="first-letter-box">
                        <span className={'all' === letter ? 'letter active' : 'letter'} role='none'
                              onClick={() => this.selectLetter('all')}>{this.props.intl.messages['QuanBuPinPai'] || '全部品牌'}</span>
                        {
                            item.keyArr.map(l => {
                                return (
                                    <span className={l === letter ? 'letter active' : 'letter'} role='none'
                                          onClick={() => this.selectLetter(l)} key={l}>{l}</span>
                                )
                            })
                        }
                    </div>
                    <div className="brand-item-box-main">
                        {
                            item.brandList[letter].map((brand, bIndex) => {
                                return (
                                    <div className="brand-box-card" key={bIndex}
                                         onClick={() => this.selectQuery(item.type_, brand)} role={'none'}>
                                        <div className="img-box">
                                            {
                                                brand.img_ ? (
                                                    <img src={brand.img_ + '_100'} alt=""/>
                                                ) : (
                                                    <span title={brand.name_}>{brand.name_}</span>
                                                )
                                            }
                                        </div>
                                        <div className="info-box">
                                            <div className="title-box">
                                                <p className="title ellipsis-2" title={brand.name_}>{brand.name_}</p>
                                                <p className="tips ellipsis-2"
                                                   title={brand.introduce_}>{brand.introduce_}</p>
                                            </div>
                                        </div>
                                    </div>

                                )
                            })

                        }
                    </div>
                </div>
                    ;
            default:
                return (
                    <div className='nav-service-item-box' key={index}>
                        {
                            item.children.map((sub, subIndex) => {
                                return (
                                    <div className="item-box-card"
                                         key={subIndex}
                                         role={'none'}
                                         onClick={() => this.selectQuery(item.type_, sub)}
                                    >
                                        <span title={sub.name || sub.name_}>{sub.name || sub.name_}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                );
        }
    };
    handleClassifyList = (data, navigation) => {
        const {typeList, brandList, tagList, propertyList} = data;
        let results = [];
        if (typeList.length > 0) {
            let typeData = {};
            typeData.name = this.getClassifyByDecorateName(1, navigation);
            typeData.hidden_ = this.getClassifyByDecorateHidden(1, navigation);
            typeData.seq_ = this.getClassifyByDecorateSeq(1, navigation);

            typeData.children = typeList;
            typeData.type_ = 'type';
            typeData.id_ = typeData.type_;
            results.push(typeData)
        }
        if (brandList.length > 0) {
            let brandData = {};
            let brandList_ = {};
            let children = [];
            brandList.forEach(brand => {
                if (brand.is_view_shop_) {
                    children.push(brand);
                    if (!brandList_[brand.first_letter_]) {
                        brandList_[brand.first_letter_] = [];
                    }
                    brandList_[brand.first_letter_].push(brand)
                }
            });

            brandData.keyArr = Object.keys(brandList_).sort();
            brandData.brandList = {all: children, ...brandList_};
            brandData.name = this.getClassifyByDecorateName(3, navigation);
            brandData.hidden_ = this.getClassifyByDecorateHidden(3, navigation);
            brandData.seq_ = this.getClassifyByDecorateSeq(3, navigation);
            brandData.children = children;
            brandData.type_ = 'brand';
            brandData.id_ = brandData.type_;
            results.push(brandData)
        }
        if (tagList.length > 0) {
            let tagData = {};
            tagData.name = this.getClassifyByDecorateName(2, navigation);
            tagData.hidden_ = this.getClassifyByDecorateHidden(2, navigation);
            tagData.seq_ = this.getClassifyByDecorateSeq(2, navigation);

            tagData.children = tagList;
            tagData.type_ = 'tag';
            tagData.id_ = tagData.type_;
            results.push(tagData)
        }
        if (propertyList.length > 0 && (navigation && navigation.classify_list_ && navigation.classify_list_.find(item => item.classify_type_ === 4))) {
            let propertyDate = this.handlePropertyByDecorateSort(4, propertyList, navigation);
            results = results.concat(propertyDate)
        }
        let arr = [];
        let classifyList = [];
        results.forEach(item => {
            if (item && item.type_ === 'type') {
                classifyList = item.children
            }
            arr.push(item)
        });
        if (navigation && navigation.type_tree_ && navigation.type_tree_.type_) {
            classifyList = arr
        }

        classifyList = classifyList.sort((a, b) => {
            return a.seq_ - b.seq_
        });
        classifyList = classifyList.filter(item => {
            return !item.hidden_
        });
        return classifyList || []
    };
    navClick = (btn) => {
        const {history} = this.props;
        if (!btn.target_) {
            message.info('未知链接类型，无法跳转，请联系客服');
            return;
        }
        if (btn.target_.type_ === 8) {
            const newTab = window.open('about:blank');
            newTab.location.href = btn.target_.val_;
            return;
        }
        if (btn.target_.type_ === 33) {
            this.toBitMap();
            return;
        }
        if (!btn.newLocation) return;
        if (btn.newLocation.checkLogin) {
            RenderUtil.renderLoginModal.call(this.props.intl);
            return;
        }
        const path = `${btn.newLocation.pathname}?${qs.stringify(btn.newLocation.query)}`;
        history.push(path);
        this.setState({
            keyword: ''
        })
    };
    selectQuery = (type, item) => {
        const {history} = this.props;
        const query = {};
        switch (type) {
            case 'type':
                Object.assign(query, {type_: item.all_ids_});
                break;
            case 'tag':
                Object.assign(query, {tag_: item.id_});
                break;
            case 'brand':
                Object.assign(query, {brand_: item.id_});
                break;
            default: // 属性
        }
        // 关闭
        this.menuItemMouseLeave();
        this.setState({
            keyword: ''
        });
        const path = `/goods/list?${qs.stringify(query)}`;
        if (history.location.pathname === '/goods/list') {
            history.replace(path);
        } else {
            history.push(path);
        }
    };
    toPage = (pathname) => {
        if (!pathname) return;
        if (!this.isLogin) {
            this.toLogin();
            return;
        }
        this.props.history.push(pathname)
    };
    toLogin = () => {
        const companyId = StorageUtil.getItem(LocalConst.companyId);
        window.location.href = `${UrlUtil.getAccountUrl(companyId)}/login`;
    };
    toLogout = () => {
        CommonUtil.logout()
        // CommonUtil.clearAccount();
        // this.props.history.push('/home')
    };
    //切换账号
    exchangeAccount = () => {
        SystemFetch.getAuthCode(null, rs => {
            if (rs.status !== 1) {
                message.error(rs.message);
                return;
            }
            if (this.isExperience) {
                // 体验账号切换到管理端
                CommonUtil.toMgrExperience();
            } else {
                const host = UrlUtil.getAccountUrl();
                window.location.href = `${host}/company?currentUser=${this.user.login_}&authCode=${rs.data}`
            }
        })

    };
    toLink = (target, name) => {
        if (typeof target === "undefined" || !target.type_) return;
        switch (target.type_) {
            case 8: //外部链接
                if (!CheckUtil.isUrl(target.val_)) return;
                window.location.href = `${target.val_}`;
                break;
            default:
                const newLocation = CommonUtil.getDecorateLocation(target);
                this.props.history.push({pathname: newLocation.pathname, search: qs.stringify(newLocation.query)});
        }
    };

    handleAffixItem = item => {
        const companyData = StorageUtil.getItem(LocalConst.companyData) || {};
        const {broadside_ = {}, intl} = this.props;
        switch (item.type_) {
            case 1:
                const url = `${UrlUtil.getMShopUrl()}/?companyId=${companyData.id_}`;
                return (
                    <div className="qrcode-box">
                        <div className="img-box">
                            <QRCode size={136} value={url}/>
                            <p className="txt">{intl.messages['WXSYS_DHGBJ'] || '微信扫一扫，订货更便捷'}</p>
                        </div>
                        {
                            companyData.wx_public_img_ &&
                            <div className="img-box">
                                <img src={companyData.wx_public_img_} alt=""/>
                                <p className="txt">{intl.messages['GZWXGZH'] || '关注微信公众号'}</p>
                            </div>
                        }
                    </div>
                );
            case 2:
                return (
                    <div className="service-box">
                        <dl>
                            <dt>{intl.messages['FuWuReXian'] || '服务热线'}</dt>
                            <dd>
                                <SvgIcon href="icon-service-phone"/>
                                <span className="tel">{broadside_.service_tel_}</span>
                            </dd>
                        </dl>
                        {
                            broadside_.service_list_ && broadside_.service_list_.length > 0 &&
                            <dl>
                                <dt>{intl.messages['ZaiXianKeFu'] || '在线客服'}</dt>
                                {
                                    (broadside_.service_list_ || []).map((service, index) => {
                                        return (
                                            <dd key={index}>
                                                <a className="service-QQ"
                                                   href={`http://wpa.qq.com/msgrd?v=3&uin=${service.service_qq_}&site=qq&menu=yes`}
                                                   target="_blank">
                                                    <SvgIcon href='icon-service-qq'/>
                                                    <span className="txt">{service.service_name_}</span>
                                                </a>
                                            </dd>
                                        )
                                    })
                                }

                            </dl>
                        }
                    </div>
                );
            default:
                return (
                    <div>{item.title_}</div>
                );
        }
    };

    affixOnClick = item => {
        switch (item.type_) {
            case 1:
            case 2:
                return;
            case 3:
                this.toPage('/order/list');
                break;
            case 4:
                document.body.scrollTop = 0;
                break
            // no default

        }
    };

    toggleSearchDropdown = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        this.setState({
            isShowSearchDropdown: !this.state.isShowSearchDropdown
        })
    };

    isNavPage = btn => {
        const {history: {location}} = this.props;
        const {newLocation = {}} = btn;
        let isTrue = false;
        if (newLocation.pathname === '/goods/list' && location.pathname === '/goods/list') {
            const state = location.state || {};
            let query = Object.getOwnPropertyNames(newLocation.query);
            let state_ = Object.getOwnPropertyNames(state);

            if (state.from !== 'head' && Object.keys(newLocation.query).includes('companyId') && Object.keys(newLocation.query).length === 1) {
                isTrue = true;

            } else if (state.from === 'menu') {
                query = query.filter(item => item !== 'companyId');
                state_ = state_.filter(item => item !== 'companyId' && item !== 'from');
                for (let i = 0; i < query.length; i++) {
                    const key = query[i];
                    if (newLocation.query[key] === state_[key]) {
                        isTrue = false
                    }
                }
            } else {
                query = query.filter(item => item !== 'companyId');
                state_ = state_.filter(item => item !== 'companyId' && item !== 'from');
                if (query.length === 0 && state_.length === 0) {
                    isTrue = true
                }
                for (let i = 0; i < query.length; i++) {
                    const key = query[i];
                    if (newLocation.query[key] === state[key]) {
                        isTrue = true
                    }
                }
            }
        } else {
            isTrue = location.pathname === newLocation.pathname
        }


        return isTrue
    };
    toBitMap = () => {
        SystemFetch.getOpenAuthCode().then(rs => {
            let targetHost = UrlUtil.getBitMapUrl();// 跳转域名
            window.location.href = `${targetHost}?authCode=${rs.data}&companyId=${StorageUtil.getItem(LocalConst.companyId)}`;
        });

    };

    toBatchOrder = () => {
        if (this.isLogin) {
            this.props.history.push("/goods/batch/order");
        } else {
            RenderUtil.renderLoginModal.call(this.props.intl);
        }
    };

    showCustomerServiceModal = () => {
        this.setState({
            isShowCustomerServiceModal: true,
        }, () => {
            // 获取客服列表
            this.getClientServiceList();
        });
    };

    closeCustomerServiceModal = () => {
        this.setState({
            isShowCustomerServiceModal: false,
        });
    };

    renderMessageBoxHtml = (data) => {
        const messageBoxHtml = [];
        const content_ = data.content_;
        if (!content_) return null;
        if (data.type_ === 1) { // 文本
            if (!data.is_service_user_send_msg_) {
                messageBoxHtml.push(
                    <div className="client-message-box">
                        <div className="client-message-wrap">
                            <div className="client-message">
                                {data.content_}
                            </div>
                        </div>
                    </div>
                );
            } else {
                messageBoxHtml.push(
                    <div className="service-message-box">
                        <div className="service-message-wrap">
                            <div className="service-message">
                                {data.content_}
                            </div>
                        </div>
                    </div>
                );
            }
        } else if (data.type_ === 2) { // 商品
            messageBoxHtml.push(
                <div className="goods-card-message-wrap-box">
                    <div className="goods-card-message-box">
                        <div className="goods-card-box" role={"none"} onClick={() => {this.toGoodsDetail(content_.id_)}}>
                            <div className="img-box">
                                <img src={content_.img_} alt=""/>
                            </div>
                            <div className="info-box">
                                <div className="name">{content_.name_}</div>
                                <div className="price">{content_.price_}</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if (data.type_ === 3) { // 订单
            if (content_.imgList === 1) {
                messageBoxHtml.push(
                    <div className="order-card-message-wrap-box">
                        <div className="order-card-message-box">
                            <div className="order-message-card" role={"none"} onClick={() => {this.toOrderDetail(content_.id_)}}>
                                <div className="order-card-goods-info-box">
                                    <div className="img-box">
                                        <img src={content_.imgList[0].imgSrc} alt=""/>
                                    </div>
                                    <div className="info-box">
                                        <div className="flex-box goods-name-box">
                                            <div className="goods-name ellipsis">{content_.name_}</div>
                                        </div>
                                        <div className="format">{content_.format_}</div>
                                    </div>
                                </div>
                                <div className="order-info-box">
                                    <div className="info-box">
                                        <div className="order-code">订单编码：{content_.code_}</div>
                                        <div className="order-price-box">
                                            <div className="price">{content_.total_}</div>
                                            <div className="total">共<i className="num">{content_.count_}</i>种，{content_.number_}件
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                messageBoxHtml.push(
                    <div className="order-card-message-wrap-box">
                        <div className="order-card-message-box">
                            <div className="order-message-card" role={"none"} onClick={() => {this.toOrderDetail(content_.id_)}}>
                                <div className="order-card-goods-info-box">
                                    <div className="info-box-wrap">
                                        <div className="img-card-list">
                                            {
                                                content_.imgList.map((img, index) => {
                                                    return (
                                                        <div className="img-box" key={index}>
                                                            <img src={img.imgSrc} alt=""/>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div className="img-total">
                                                共<i>{content_.count_}</i>种
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="order-info-box">
                                    <div className="info-box">
                                        <div className="order-code">订单编码：{content_.code_}</div>
                                        <div className="order-price-box">
                                            <div className="price">{content_.total_}</div>
                                            <div className="total">共<i className="num">{content_.count_}</i>种，{content_.number_}件
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }
        return messageBoxHtml;
    };

    changeMsg = (msg) => {
        this.setState({
            msg,
        });
    };

    onSend = () => {
        const {msg,currentService} = this.state;
        if (!msg || !msg.trim()) return;
        if (/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]|\uD83C[\uDC00-\uDFFF]/g.test(msg)) {
            message.info("暂不支持表情符号", window.ToastDuration);
            return;
        }
        this.setState({
            msg: ''
        }, () => {
            if (currentService.length) {
                const params = {
                    type_: 1,
                    content_: msg,
                    service_user_id_: currentService[0].service_user_id_
                };
                this.addMsgForClient(params);
            }
        });
    };

    addMsgForClient = (params) => {
        const {currentService} = this.state;
        SystemFetch.addMsgForClient(params, rs => {
            if (rs.status === 1) {
                this.getMsgList(currentService[0].client_id_, currentService[0].service_user_id_);
            }
        })
    };

    toGoodsDetail = (goodsId) => {
        this.closeCustomerServiceModal();
        this.props.history.push(`/goods/detail/${goodsId}`);
    };

    toOrderDetail = (orderId) => {
        this.closeCustomerServiceModal();
        this.props.history.push(`/order/detail/${orderId}`);
    };

    changeLang = (lang) => {
        // 创建intl 用于model
        const intl = createIntl({
            locale: lang,
            messages: messages[lang]
        });
        this.props.dispatch({
            type: "appModel/saveState",
            payload: {
                lang: lang,
                intl: intl
            }
        });
        StorageUtil.setItem(LocalConst.lang, lang, true);
    };

    render() {
        const {keywordList, keyword, isFixationHead, cartCount, isShowSearchDropdown, isShowCustomerServiceModal, tabList, serviceGroupView, msgList, currentService, msg} = this.state;
        const {pageHeader = {}, decorateInfo = {}, broadside_ = {}, typeList, brandList, tagList, propertyList, history, intl} = this.props;
        const {logo_ = '', banner_ = {}, background_ = {}, navigation_ = {}} = pageHeader;
        const {is_working_ = null, company_wx_public_img_ = null} = decorateInfo;
        const backgroundStyle = {
            'backgroundColor': background_.color_,
            'backgroundPositionX': background_.horizontal_,
            'backgroundPositionY': background_.vertical_,
            'backgroundRepeat': background_.repeat_ === 'padding' ? 'no-repeat' : background_.repeat_,
            'backgroundSize': background_.repeat_ === 'padding' ? '100% 100%' : '',
        };
        if (background_.img_) {
            backgroundStyle['backgroundImage'] = 'url(' + background_.img_ + ')'
        }
        const headerBannerStyle = {
            'height': (banner_.height_ || 0) + 'px',
        };
        const classifyStyle = {
            'height': navigation_.type_tree_ && navigation_.type_tree_.height_ + 'px',
            'backgroundColor': navigation_.background_color_ ? CommonUtil.colorRgb(navigation_.background_color_, navigation_.background_alpha_) : ''
        };
        const classifyFontStyle = {
            'color': navigation_.font_color_ ? CommonUtil.colorRgb(navigation_.font_color_, navigation_.font_alpha_) : '',
            'borderColor': navigation_.font_color_ ? CommonUtil.colorRgb(navigation_.font_color_, 10) : '',
        };

        const pathname = window.location.pathname;
        const companyName = StorageUtil.getItem(LocalConst.companyName) || '';
        const companyDate = StorageUtil.getItem(LocalConst.companyData) || {};
        const lang = StorageUtil.getItem(LocalConst.lang, true);
        let currentLang = '';
        if (lang === 'zh') {
            currentLang = intl.messages['ZHONGWEN'];
        } else if (lang === 'en') {
            currentLang = intl.messages['YINGYU'];
        } else if (lang === 'es') {
            currentLang = intl.messages['XIBANYAYU'];
        } else if (lang === 'de') {
            currentLang = intl.messages['DEYU'];
        } else if (lang === 'fr') {
            currentLang = intl.messages['FAYU'];
        } else if (lang === 'ar') {
            currentLang = intl.messages['ALABOYU'];
        } else if (lang === 'ru') {
            currentLang = intl.messages['EYU'];
        } else if (lang === 'ms') {
            currentLang = intl.messages['MALAIYU'];
        } else if (lang === 'vi') {
            currentLang = intl.messages['YUENANYU'];
        } else if (lang === 'th') {
            currentLang = intl.messages['TAIYU'];
        } else if (lang === 'id') {
            currentLang = intl.messages['YINNIYU'];
        }
        console.log('currentLang：', currentLang)
        const overlayItem = <div className='search-log-list-box'>
            <ul className="log-box">
                {
                    (keywordList || []).map((item, index) => {
                        return (
                            <li className='log-item' key={index}>
                                <span className='txt ellipsis' role='none' title={item.keywords_}
                                      onClick={(e) => this.selectKeywordLog(e, item)}>{item.keywords_}</span>
                                <span className='ope'>
                                    <span
                                        className='tips'>{item.search_count_ > 0 ?
                                        intl.formatMessage({
                                            id: 'Yue1GeShangPin'
                                        }, {num: item.search_result_})
                                        // '约' + item.search_result_ + '个商品'
                                        : (intl.messages['SouSuoLiShi'] || '搜索历史')}
                                    </span>
                                    {
                                        this.user && this.user.id_ && !keyword &&
                                        <span className='del' role="none"
                                              onClick={(e) => this.toDeleteKeywordsById(e, item.id_)}>
											{intl.messages['ShanChu'] || '删除'}

										</span>
                                    }
                                </span>
                            </li>
                        )
                    })
                }
            </ul>
            {
                this.user && this.user.id_ && !keyword &&
                <div className='keyword-foot-box'>
                    <span className='txt' role="none"
                          onClick={this.toDeleteClientAllKeywords}>{intl.messages['QuanBuShanChu'] || '全部删除'}</span>
                </div>
            }
        </div>;

        const classifyList = this.handleClassifyList(
            {
                typeList: typeList,
                brandList: brandList,
                tagList: tagList,
                propertyList: propertyList
            },
            navigation_
        );
        // 头部搜索栏
        const pageHeadMain = <div className="main-wrap">
            <div className="logo-box cur" role="none" onClick={() => this.toLink({type_: -1})}>
                <img src={logo_ || (this.companyData && this.companyData.login_) || IMGLogo} alt=""/>
            </div>
            <div className="search-wrap">
                <div className="search-box" role="none" onClick={(e) => this.toggleSearchDropdown(e)}>
                    <Input type="text"
                           className="txt"
                           placeholder={intl.messages['SPMC_GG_BH_'] || '请输入商品名称/规格/编号/首字母'}
                           value={keyword}
                           onPressEnter={() => this.searchKeyword(keyword)}
                           onChange={this.changeKeyword}/>
                    <div className="search-btn" onClick={() => this.searchKeyword(keyword)} role="none"><i
                        className='iconfont icon-sousuo'/></div>
                    {
                        isShowSearchDropdown && keywordList.length > 0 &&
                        <div className="dropdown-box">{overlayItem}</div>
                    }
                </div>
                <Badge count={cartCount} className="cart-box"
                       onClick={() => history.push("/cart")}>
                    <i className='iconfont icon-shopping_cart_s'/>{intl.messages['GouWuChe'] || '购物车'}
                </Badge>
                <Badge className="cart-box"
                       onClick={this.toBatchOrder}>
                    {intl.messages['PLXD'] || '批量下单'}
                </Badge>
            </div>

        </div>;
        return (
            <Fragment>
                <div className={`page-head-wrap page-head-wrap-fix ${isFixationHead ? 'opacity-1' : ``}`}
                     style={backgroundStyle}>
                    <div className="head-main-box">
                        <div className="page-wrap">{pageHeadMain}</div>
                    </div>
                </div>
                <div className={`page-head-wrap ${isFixationHead ? 'opacity-0' : ``}`} style={backgroundStyle}>
                    {
                        banner_.show_ &&
                        is_working_ &&
                        pathname.indexOf('/home') > -1 ?
                            <div className="header-banner-box" style={headerBannerStyle}>
                                <ImgAdapt src={banner_.img_} alt=""/>
                            </div> : null
                    }
                    <div className="shop-head-user-box">
                        <div className="main-box">
                            <div className="head-welcome-txt">{intl.formatMessage({
                                id: 'NH_HYLDYSDH'
                            }, {company: companyName})}
                                {/*`您好，欢迎来到${companyName}商城！`*/}
                            </div>
                            <div className="head-user-nav-box">
                                {
                                    this.applicationStatus.application_38_status_ && this.switchLanguageType && this.switchLanguageType === 2 &&
                                    <Popover
                                        placement="bottom"
                                        trigger="hover"
                                        content={
                                            <div className="lang-card-box">
                                                <div className={lang === 'zh' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('zh')}>
                                                    {intl.messages['ZHONGWEN'] || '汉语'}
                                                </div>
                                                <div className={lang === 'en' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('en')}>
                                                    {intl.messages['YINGYU'] || '英语'}
                                                </div>
                                                <div className={lang === 'es' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('es')}>
                                                    {intl.messages['XIBANYAYU'] || '西班牙语'}
                                                </div>
                                                <div className={lang === 'de' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('de')}>
                                                    {intl.messages['DEYU'] || '德语'}
                                                </div>
                                                <div className={lang === 'fr' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('fr')}>
                                                    {intl.messages['FAYU'] || '法语'}
                                                </div>
                                                <div className={lang === 'ar' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('ar')}>
                                                    {intl.messages['ALABOYU'] || '阿拉伯语'}
                                                </div>
                                                <div className={lang === 'ru' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('ru')}>
                                                    {intl.messages['EYU'] || '俄语'}
                                                </div>
                                                <div className={lang === 'ms' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('ms')}>
                                                    {intl.messages['MALAIYU'] || '马来语'}
                                                </div>
                                                <div className={lang === 'vi' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('vi')}>
                                                    {intl.messages['YUENANYU'] || '越南语'}
                                                </div>
                                                <div className={lang === 'th' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('th')}>
                                                    {intl.messages['TAIYU'] || '泰语'}
                                                </div>
                                                <div className={lang === 'id' ? "lang-card active" : "lang-card"} role="none" onClick={() => this.changeLang('id')}>
                                                    {intl.messages['YINNIYU'] || '印尼语'}
                                                </div>
                                            </div>
                                        }
                                    >
                                        <div className="nav-card language-box">
                                            <p><i className='iconfont icon-guojihua'/>{currentLang}</p>
                                        </div>
                                    </Popover> || null
                                }
                                <Popover
                                    placement="bottom"
                                    trigger="hover"
                                    content={
                                        <div className="nav-card-main">
                                            <div className="qr-code-box">
                                                <div className="code-box">
                                                    <img src={companyDate.android_url_ || IMGDownloadQrCode} alt=""/>
                                                </div>
                                                <p>Android</p>
                                            </div>
                                            <div className="qr-code-box">
                                                <div className="code-box">
                                                    <img src={companyDate.ios_url_ || IMGDownloadQrCode} alt=""/>
                                                </div>
                                                <p>IOS</p>
                                            </div>
                                        </div>
                                    }
                                >
                                    <div className="nav-card">
                                        <p>{intl.messages['ZSJDH'] || '在手机订货'}</p>
                                    </div>
                                </Popover>
                                {
                                    company_wx_public_img_ &&
                                    <Popover
                                        placement="bottom"
                                        trigger="hover"
                                        content={
                                            <div className="nav-card-main">
                                                <div className="qr-code-box">
                                                    <div className="code-box"><img src={company_wx_public_img_} alt=""/>
                                                    </div>
                                                    <p>{intl.messages['SYS_GZWXGZH'] || '扫一扫，关注微信公众号'}</p>
                                                </div>
                                            </div>
                                        }
                                    >
                                        <div className="nav-card">
                                            <p>{intl.messages['GuanZhuWoMen'] || '关注我们'}</p>
                                        </div>
                                    </Popover>
                                }

                                <div className="nav-card">
                                    <p className="user-nav-card" role="none"
                                       onClick={() => this.toPage('/collect/list')}>{intl.messages['WoDeShouCang'] || '我的收藏'}</p>
                                </div>
                                <Popover
                                    placement="bottom"
                                    trigger="hover"
                                    content={
                                        <div className="user-nav-card-box">
                                            <div className="user-nav-card" role="none"
                                                 onClick={() => this.toPage('/user')}>
                                                {intl.messages['WoDeZhangHao'] || '我的账号'}
                                            </div>
                                            {
                                                this.isLogin && this.user && this.user.bind_phone_ &&
                                                <div className="user-nav-card" role="none"
                                                     onClick={this.exchangeAccount}>
                                                    {intl.messages['QieHuanZhangHao'] || '切换账号'}
                                                </div>
                                            }
                                            <div className="user-nav-card" role="none"
                                                 onClick={() => this.toPage('/keep/list')}>
                                                {intl.messages['GouMaiJiLu'] || '购买记录'}
                                            </div>
                                            {
                                                this.isLogin &&
                                                <div className="user-nav-card" role="none"
                                                     onClick={this.toLogout}>
                                                    {intl.messages['TuiChuDengLu'] || '退出登录'}
                                                </div>
                                            }
                                            {
                                                !this.isLogin &&
                                                <div className="user-nav-card" role="none"
                                                     onClick={this.toLogin}>{intl.messages['QuDengLu'] || '去登录'}</div>
                                            }
                                        </div>
                                    }
                                >
                                    <div className="nav-card">
                                        <p>{intl.messages['GeRenZhongXin'] || '个人中心'}</p>
                                    </div>
                                </Popover>
                            </div>
                        </div>
                    </div>
                    <div className="head-main-box">
                        {
                            !background_.is_hide_border_ &&
                            <div className="line-wrap"/>
                        }
                        <div className="page-wrap">
                            {pageHeadMain}
                            <div className="nav-wrap">
                                {
                                    !(navigation_.classify_title_ && navigation_.classify_title_.hidden_) &&
                                    <div className="menu-wrap">
                                        {
                                            !navigation_.classify_title_ &&
                                            <div className="menu-title">
                                                {intl.messages['QBSPFL'] || '全部商品分类'} <i
                                                className="icon-fenlei iconfont"/>
                                            </div>
                                        }
                                        {
                                            navigation_.classify_title_ &&
                                            !navigation_.classify_title_.hidden_ &&
                                            <div className="menu-title">
                                                {navigation_.classify_title_.name_}
                                                <i className="icon-fenlei iconfont"/>
                                            </div>
                                        }
                                        <div
                                            className={navigation_.type_tree_ && navigation_.type_tree_.show_ && (pathname === '/' || pathname.indexOf('/home') > -1) ? "menu-box dis-show" : "menu-box"}
                                            onMouseLeave={this.menuItemMouseLeave}
                                            ref='jsMenuBox'>
                                            <Scrollbars className="menu-main-box" style={classifyStyle}>
                                                {
                                                    (classifyList || []).map((item, index) => {
                                                        return (
                                                            <span
                                                                role={'none'}
                                                                className="menu-item"
                                                                data-id={item.id_}
                                                                onMouseEnter={this.menuItemMouseEntre}
                                                                style={classifyFontStyle}
                                                                key={index}
                                                                onClick={() => this.selectQuery(item.type_ || 'type', item)}
                                                            >
                                                                {item.name}
                                                                {
                                                                    item.children && item.children.length > 0 &&
                                                                    <i className="goto iconfont icon-jump"
                                                                       style={classifyFontStyle}/>
                                                                }
                                                            </span>
                                                        )
                                                    })
                                                }
                                            </Scrollbars>
                                            {
                                                classifyList.filter(item => {
                                                    return !item.hidden_ && item.children && item.children.length > 0
                                                }).map((item, index) => {
                                                    return (
                                                        <div className="menu-sub-box" id={`jsSelect_${item.id_}`}
                                                             key={index}>
                                                            {
                                                                !(navigation_.type_tree_ && navigation_.type_tree_.type_) ? (
                                                                    item.children.map((sub, subIndex) => {
                                                                        return this.renderMenuItem(sub, subIndex)
                                                                    })
                                                                ) : (
                                                                    this.renderMenuSubBoxList(item, index)
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                                <div className="nav-box">
                                    <Fragment>
                                        {
                                            (navigation_.buttons_ || []).filter(item => {
                                                return !item.hidden_
                                            }).map((btn, index) => {
                                                const cls = classnames('nav-item', {
                                                    'active': this.isNavPage(btn)
                                                });
                                                return (
                                                    <span className={cls}
                                                          role={'none'}
                                                          onClick={() => this.navClick(btn)}
                                                          key={index}>{btn.name_}</span>
                                                )
                                            })
                                        }
                                    </Fragment>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <Affix className="affix-box">
                    <section>
                        <div className="affix-item" role="none" onClick={this.showCustomerServiceModal}>
                            <i className={`iconfont icon-kefu`}/>
                        </div>
                        {
                            (broadside_.fixbar_list_ || []).filter(item => !item.hidden_).map((item, index) => {
                                return (
                                    <Popover placement="leftTop" content={this.handleAffixItem(item)}
                                             getPopupContainer={() => this.affix} trigger="hover" key={index}>
                                        <div className="affix-item" ref={ref => this.affix = ref} role="none"
                                             onClick={() => this.affixOnClick(item)}>
                                            <i className={`iconfont ${item.icon_}`}/>
                                        </div>
                                    </Popover>
                                )
                            })
                        }
                    </section>
                </Affix>
                <div className={`customer-service-center-pop ${isShowCustomerServiceModal ? 'dis-show' : 'dis-hide'}`}>
                    <div className="title-box">
                        <div className="title">客服中心</div>
                        <div className="close-box cur" role={"none"} onClick={this.closeCustomerServiceModal}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                 fill="none">
                                <path
                                    d="M8.92473 7.99916L13.6122 2.41166C13.6908 2.31881 13.6247 2.17773 13.5033 2.17773H12.0783C11.9944 2.17773 11.914 2.21523 11.8587 2.27952L7.99258 6.88845L4.12651 2.27952C4.07294 2.21523 3.99258 2.17773 3.90687 2.17773H2.48187C2.36044 2.17773 2.29437 2.31881 2.37294 2.41166L7.06044 7.99916L2.37294 13.5867C2.35534 13.6074 2.34405 13.6327 2.3404 13.6596C2.33676 13.6865 2.34092 13.7139 2.35239 13.7386C2.36386 13.7632 2.38216 13.784 2.40511 13.7985C2.42806 13.8131 2.4547 13.8207 2.48187 13.8206H3.90687C3.9908 13.8206 4.07115 13.7831 4.12651 13.7188L7.99258 9.10988L11.8587 13.7188C11.9122 13.7831 11.9926 13.8206 12.0783 13.8206H13.5033C13.6247 13.8206 13.6908 13.6795 13.6122 13.5867L8.92473 7.99916Z"
                                    fill="black" fill-opacity="0.45"/>
                            </svg>
                        </div>
                    </div>
                    <div className="customer-service-center-body">
                        <div className="user-list-box">
                            <div className="user-list-tab-box">
                                {
                                    tabList.map(tab => {
                                        return (
                                            <div key={tab.id} className={`tab cur ${tab.isChecked ? 'active' : ''}`} role={"none"} onClick={() => {this.changeTab(tab.id)}}>{tab.name}</div>
                                        )
                                    })
                                }
                            </div>
                            <div className="user-list">
                                {
                                    Object.keys(serviceGroupView).length &&
                                    <div className="user-list-wrap">
                                        {
                                            Object.keys(serviceGroupView).map(key => {
                                                return (
                                                    <div key={key} className={serviceGroupView[key][0].active ? "user-card-box active cur" : "user-card-box cur"} role={'none'} onClick={() => {this.toMsgList(key)}}>
                                                        <div className="img-box">
                                                            {
                                                                serviceGroupView[key][0].service_user_img_ ? (
                                                                    <img src={serviceGroupView[key][0].service_user_img_} alt={""}/>
                                                                ) : (
                                                                    <SvgIcon href={'icon-avatar'}/>
                                                                )
                                                            }
                                                        </div>
                                                        <div className="info-box">
                                                            <div className="user-name-box">
                                                                <div className="name">{serviceGroupView[key][0].service_user_name_}</div>
                                                                <div className="time">{serviceGroupView[key][0].create_time_}</div>
                                                            </div>
                                                            <div className="message-box">
                                                                {
                                                                    serviceGroupView[key][0].notReadCount ? (
                                                                        <span className="message"><i className="tag" style={{color: '#0B9ED9'}}>[未读]</i>{serviceGroupView[key][0].content_}</span>
                                                                    ) : (
                                                                        <span className="message"><i className="tag">[已读]</i>{serviceGroupView[key][0].content_}</span>
                                                                    )
                                                                }
                                                                {
                                                                    serviceGroupView[key][0].notReadCount ?
                                                                        <span className="count">{serviceGroupView[key][0].notReadCount}</span> :
                                                                        <span className="count opacity-0"/>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div> || null
                                }
                            </div>
                        </div>
                        <div className="chat-box">
                            <div className="chat-card-box">
                                <div className="user-img-box">
                                    <div className="img-box">
                                        {
                                            currentService.length && currentService[0].service_user_img_ ?
                                                <img src={currentService[0].service_user_img_} alt=""/> :
                                                <SvgIcon href={'icon-avatar'}/>
                                        }
                                    </div>
                                    {
                                        currentService.length && currentService[0].service_user_name_ &&
                                        <div className="user-name">{currentService[0].service_user_name_}</div> || null
                                    }
                                </div>
                                <div className="chat-message-box">
                                    {
                                        msgList.map(data => {
                                            return (
                                                <div className="message-cart-wrap-box" key={data.id_}>
                                                    <div className="message-time">
                                                        <span className="date-txt">{data.create_time_}</span>
                                                    </div>
                                                    {this.renderMessageBoxHtml(data)}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className="chat-input-box">
                                <div className="input-box">
                                    <textarea placeholder="请输入" maxLength={500} value={msg} onChange={(event) => this.changeMsg(event.target.value)}/>
                                </div>
                                <div className="btn-box tr">
                                    <button type="button" className="btn" onClick={this.onSend}>发送</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`mask ${isShowCustomerServiceModal ? 'dis-show' : 'dis-hide'}`}/>
            </Fragment>
        )
    }
}

export default PageHeader
